import { Bet } from "@models";

export function shouldShowBetSlipStatus(bet: Bet) {
	return (
		bet.betSlipStatus.abrv.includes("cashout") ||
		bet.betSlipStatus.abrv === "paid-out"
	);
}
